import { useSelect, select } from '@wordpress/data'
import { useEffect, useState } from '@wordpress/element';
import { FormTokenField } from '@wordpress/components';
import { Fragment } from '@wordpress/element'
import { equals } from 'ramda';

import { useTaxonomies } from '../hooks/index.js'


const queryPosts = (query) => {
    const { postTypes = [], taxonomies } = query;

    return postTypes
        .reduce((posts, postType) => {
            return [
                ...posts,
                ...select('core').getEntityRecords('postType', postType.slug) || []
            ]
        }, [])
}

const usePostTypes = () => {
    const { postTypes = [] } = useSelect((select) => ({
        postTypes: select('core').getPostTypes()
    }))

    return postTypes
}



const PostTypesFormTokenField = ({
    onChange
}) => {
    const postTypes = usePostTypes()
    const [value, setValue] = useState([])

    return (
        <FormTokenField
            value={value}
            label="Add Post Types"
            suggestions={postTypes.map(t => t.name)}
            __experimentalExpandOnFocus={true}
            onChange={(value) => {
                setValue(value)
                if (onChange) {
                    onChange(value.map(v => postTypes.find(t => t.name === v)))
                }
            }}
        />
    )
}



export const PostQueryControl = ({
    onQueryChange
}) => {
    const [query, setQuery] = useState({})
    const taxonomies = useTaxonomies()
    const [availableTaxonomies, setAvailableTaxonomies] = useState([])

    useEffect(() => {
        if (!query || !query.postTypes) return;
        const posts = queryPosts(query);
        const postTypeSlugs = query.postTypes.map(postType => postType.slug)
        const postTypeTaxonomies = query.postTypes.reduce((taxonomies, postType) => ([
            ...taxonomies,
            ...postType.taxonomies.filter(taxonomy => !taxonomies.includes(taxonomy))
        ]), [])
        const newAvailableTaxonomies = taxonomies
            .filter(taxonomy => {
                return postTypeTaxonomies.includes(taxonomy)
                    || taxonomy.types.find(t => postTypeSlugs.includes(t))
            }).map(taxonomy => ({
                name: taxonomy.name,
                rest_base: taxonomy.rest_base,
                terms: taxonomy.terms.filter(term => term.count > 0)
            }))
        if (equals(newAvailableTaxonomies, availableTaxonomies)) return;
        setAvailableTaxonomies(newAvailableTaxonomies)
    }, [query, availableTaxonomies])

    useEffect(() => {
        const { postTypes, ...otherParams } = query
        if (!postTypes || !otherParams) return

        const taxonomies = Object.entries(otherParams)
            .reduce((taxonomies, [taxonomy, terms]) => ({
                ...taxonomies,
                [taxonomy]: terms.map(term => term.id)
            }), [])
        onQueryChange({
            types: postTypes.filter(v => v && v.rest_base).map(t => t.rest_base),
            ...taxonomies
        })
    }, [query])

    return (
        <Fragment>
            <PostTypesFormTokenField onChange={(postTypes) => {
                setQuery(query => ({ ...query, postTypes }))
            }} />
            {
                availableTaxonomies.map(taxonomy => (
                    <FormTokenField
                        key={taxonomy.rest_base}
                        label={taxonomy.name}
                        __experimentalExpandOnFocus={true}
                        value={query[taxonomy.rest_base]?.map(t => t.name)}
                        suggestions={taxonomy.terms.map(t => t.name)}
                        onChange={(terms) => {
                            setQuery(query => ({
                                ...query,
                                [taxonomy.rest_base]: terms.map(name => taxonomy.terms.find(term => term.name === name))
                            }))
                        }}
                    />
                ))
            }


        </Fragment>
    )
}

export default PostQueryControl